const normalizeUrl = (url = '') => {
    if (!url) {
        return '';
    }

    return url.endsWith('/') ? url : `${url}/`;
};

export const BASE_URL = normalizeUrl(
    process.env.REACT_APP_SITE_URL || window.location.origin
);

const getUrl = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    if (apiBaseUrl) {
        return normalizeUrl(apiBaseUrl);
    }

    if (process.env.REACT_APP_DEBUG === '1') {
        return normalizeUrl(process.env.REACT_APP_URL);
    }

    return '/';
};

const backEnd = {
    url: `${getUrl()}api/`,
};

export default backEnd;
